/**
 * AiWorkflowPresetService
 * Service for managing AI workflow presets
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for AI workflow preset CRUD operations with vendor and system preset endpoints
 */
export class AiWorkflowPresetService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiWorkflowPresetService.DEFAULT_SERVICE_PATH,
            basePath: AiWorkflowPresetService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY VENDOR ====================
    /**
     * Get all workflow presets for a vendor
     * @param vendorId - The vendor ID
     * @returns Array of workflow presets for the vendor
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all workflow presets for a vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of workflow presets
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
    // ==================== GET SYSTEM PRESETS ====================
    /**
     * Get all system workflow presets
     * @returns Array of system workflow presets
     */
    async getSystemPresets() {
        const response = await this.getSystemPresetsRaw();
        return response.data ?? [];
    }
    /**
     * Get all system workflow presets with full response
     * @returns ResponseData with array of system workflow presets
     */
    getSystemPresetsRaw() {
        const url = this.buildUrl('system');
        return this.http.get(url);
    }
}
AiWorkflowPresetService.DEFAULT_SERVICE_PATH = 'ai-management';
AiWorkflowPresetService.BASE_PATH = 'api/ai/workflow-presets';
//# sourceMappingURL=AiWorkflowPresetService.js.map